import { ReactNode } from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import './RestrictedAccess.css';

interface RestrictedAccessProps {
  feature?: string;
  isRestricted?: boolean;
  children?: ReactNode;
  restrictedMessage?: ReactNode;
}

const RestrictedAccess: React.FC<RestrictedAccessProps> = ({
  children,
  isRestricted = true,
  restrictedMessage,
}) => {
  if (!isRestricted) return <>{children}</>;

  return (
    <div className="restricted-wrapper">
      <div className="restricted-blurred">{children}</div>

      <div className="restricted-overlay">
        <div className="restricted-box">
          <LockClosedIcon className="mb-2 w-10 h-10" color="#D02591" />
          {restrictedMessage ? (
            restrictedMessage
          ) : (
            <>
              <h6>This feature is available only for authenticated users</h6>
              <h6>
                See all the{' '}
                <a href="/plans" style={{ color: '#D02591' }}>
                  plans here
                </a>
                .
              </h6>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RestrictedAccess;
